// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {TooltipEl} from 'common/components/tooltip';
import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {hasSlot} from 'common/util/dom';

import type {Section} from './index';

export function template(this: Section) {
  const {isOpen} = this.state;
  const canClickRow = this.attr(`enable-row-click`);
  const hiddenTitle = !this.attr(`header-title`);
  const hasActions = hasSlot(this, `actions`) || !this.attr(`non-collapsible`);

  return (
    <div
      sel='.mp-section'
      class={{
        'is-closed': !isOpen,
        inline: this.attr(`theme`) === this.helpers.CollapsibleTheme.INLINE,
      }}
    >
      <div
        sel='.mp-section-title-container'
        class={{
          'is-clickable': canClickRow && !this.attr(`non-collapsible`),
          'is-non-collapsible': this.attr(`non-collapsible`),
          hidden: hiddenTitle,
        }}
        on={{
          click: canClickRow ? this.helpers.toggleOpen : null,
        }}
      >
        {this.helpers.hasSlot(this, `title`) ? (
          <div sel='.mp-section-title.is-uppercase'>
            <slot attrs={{name: `title`}} />
          </div>
        ) : !hiddenTitle ? (
          <div
            sel='.mp-section-title'
            attrs={{
              elref: `sectionTitle`,
            }}
            class={{
              'is-clickable': !this.attr(`non-collapsible`),
              'is-uppercase': !this.attr(`header-title-lowercase`),
              red: this.attr(`theme`) === this.helpers.CollapsibleTheme.RED,
            }}
            on={{
              click: !canClickRow && !this.attr(`non-collapsible`) ? this.helpers.toggleOpen : null,
            }}
          >
            {this.attr(`header-title`)}
            {this.attr(`tooltip-text`) ? <TooltipEl>{this.attr(`tooltip-text`)}</TooltipEl> : null}
          </div>
        ) : null}

        {/* collapse button */}
        {hasActions && (
          <div sel='.mp-section-actions'>
            {hasSlot(this, `actions`) && <slot attrs={{name: `actions`}} />}
            {!this.attr(`non-collapsible`) && (
              <ButtonEl
                class={{
                  hidden: this.attr(`hide-caret`),
                }}
                attrs={{
                  icon: isOpen ? `caret-up` : `caret-down`,
                  theme: ButtonTheme.Tertiary,
                }}
                on={{
                  click: !canClickRow ? this.helpers.toggleOpen : null,
                }}
              />
            )}
          </div>
        )}
      </div>

      {/* main content body */}
      <div sel='.mp-section-body' attrs={{'aria-hidden': !isOpen}}>
        <slot />
      </div>
    </div>
  );
}
